module.exports = __webpack_public_path__ + "bee4ebf0ec1e2be5caaabebee0ec9152.svg";


//////////////////
// WEBPACK FOOTER
// ./components/forms/select_reports/group-5-copy.svg
// module id = 1035
// module chunks = 0